module.exports = __webpack_public_path__ + "media/src/public/img/promo-slide-image-1265c5f0daeffdb091fd066f6f4b2d6d.webp";